import { render, staticRenderFns } from "./ModalRealinhar.vue?vue&type=template&id=0b647550&scoped=true"
import script from "./ModalRealinhar.vue?vue&type=script&lang=js"
export * from "./ModalRealinhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b647550",
  null
  
)

export default component.exports